import { render, staticRenderFns } from "./DashboardFlexibleLayout.vue?vue&type=template&id=2b47dd51&"
import script from "./DashboardFlexibleLayout.vue?vue&type=script&lang=js&"
export * from "./DashboardFlexibleLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports